import styled from "@emotion/styled";

export const FormContainer = styled.form`
  width: 100%;
`;

export const FormBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["4"]};
  width: 100%;
  overflow-x: hidden;
  position: relative;
  z-index: 1;
`;

export const FormLabel = styled.label`
  font-size: ${({ theme }) => theme.fontSizes["paragraph-sm"]};
  line-height: ${({ theme }) => theme.lineHeights["paragraph-sm"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.text.primary};
  width: 100%;
`;

export const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing["2"]};
  justify-content: flex-end;
  padding-top: ${({ theme }) => theme.spacing[4]};
  border-top: 1px solid ${({ theme }) => theme.colors.border.default};
`;
